import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

//style
import './App.css';

//helpers
import { LoginRedirect } from './helpers/LoginRedirect';
import { UseAccessToken } from './helpers/UseAccessToken';
//css
import './App.css';

export default function App() {
  return (
    <>
      <AuthenticatedTemplate>
        <UseAccessToken />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginRedirect />
      </UnauthenticatedTemplate>
    </>
  );
}
